import type {ReactElement} from 'react';
import {ImageLabelTile} from '@Components/ai-chat-window/components/change-style-dropdown/components/image-label-tile/image-label-tile';
import type {ThemeTileProps} from './theme-tile.types';

export function ThemeTile({option, onSelect, isSelected = false}: ThemeTileProps): ReactElement {
  const handleClick = (): void => {
    onSelect(option.theme);
  };

  return <ImageLabelTile imageUrl={option.imageUrl} label={window.i18next.t(option.label)} onClick={handleClick} isSelected={isSelected} />;
}
